import AgentService from '../../../core/services/agent.service'
import {
  clearOfferDocumentId,
  getUserName,
} from '../../../core/services/storage.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { PortalRaw, View } from './Portal.view'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'

export class PortalPresenter implements LifecyclePresenter<View> {
  private view!: PortalRaw

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    const agentId = getUserName()
    try {
      const agent = await AgentService.getAgentBroker(agentId)
      if (agent.agencyId <= 0) {
        this.view.props.history.push('/portal/sign-up')
      }
      dataLayer.page.category.applicationStep = 'portal-agentBroker'
      AdobeEventManager.emit('portal', 'calc_step')
    } catch (error) {
      console.log(error)
    }
  }

  onNewOffer = () => {
    clearOfferDocumentId()
    this.view.props.history.push('/calculator/vehicles')
  }
}
